import { Anchor } from "@/app/components/anchor"

interface QuoteCTAProps {
  ctaUrl?: string
  ctaLabel?: string
}

const QuoteCTA = ({
  ctaUrl = "https://app.citizenshipper.com/shipments/new",
  ctaLabel = "Get a Quote",
}: QuoteCTAProps) => {
  return (
    <div className="my-12 py-8 max-w-sm mx-auto bg-white rounded-lg border border-gray200 p-6">
      <div className="space-y-4 p-2">
        <h2 className="text-xl font-semibold text-center text-gray-800">
          Got something you need moved?
        </h2>

        <p className="text-center text-gray-600 leading-6">
          Start by getting quotes from our network of trusted service providers.
        </p>

        <Anchor
          href={ctaUrl}
          className="w-full block text-center bg-blue7 hover:bg-blue-700 hover:text-white text-white font-medium py-2 px-4 rounded-md transition duration-150 ease-in-out"
        >
          {ctaLabel}
        </Anchor>
      </div>
    </div>
  )
}
export default QuoteCTA
